module.exports = __webpack_public_path__ + "static/media/back-arrow.3dbcb056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/createEntityModal/back-arrow.svg
// module id = 1924
// module chunks = 0